<template>
    <section class="section section-shaped section-lg my-0">
        <div class="shape shape-style-1 bg-gradient-default">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
        <div class="container pt-lg-md">
            <div class="row justify-content-center">
                <div class="col-lg-10">
                    <card type="secondary" shadow
                          header-classes="bg-white pb-5"
                          body-classes="px-lg-5 py-lg-5"
                          class="border-0">
                        <template>
                            <div class="text-center mb-4">
                                <h3>Request an Quality+ IT tool account for your Organisation</h3>
                            </div>
                            <br>
                            <form role="form">
                                <p>Please select what type of entity you are representing:<p>
                                <div class="row pl-3">
                                    <!-- <base-radio name="Host Company" class="mb-4 col" v-model="contactFormData.selected" inline>
                                        Host Company
                                    </base-radio> -->
                                    <base-radio name="Intermediary Organisation" class="mb-4 col" v-model="contactFormData.selected" inline>
                                        Intermediary Organisation
                                    </base-radio>
                                    <base-radio center name="Sending Organisation (School)" class="mb-4 col" v-model="contactFormData.selected" inline>
                                        Sending Organisation (School)
                                    </base-radio>
                                </div>
                                <p>Please enter your Organisation's details:<p>
                                <div class="row">
                                    <base-input alternative
                                                required
                                                v-model="contactFormData.orgName"
                                                class="mb-3 col noshadow"
                                                placeholder="Organisation Name"
                                                addon-left-icon="ni ni-hat-3">
                                    </base-input>
                                    <base-input alternative
                                                v-model="contactFormData.orgCountry"
                                                class="mb-3 col noshadow"
                                                placeholder="Country"
                                                addon-left-icon="ni ni-hat-3">
                                    </base-input>
                                </div>
                                <div class="row">
                                    <base-input alternative
                                                v-model="contactFormData.orgAddress"
                                                class="mb-3 col noshadow"
                                                placeholder="Full Address"
                                                addon-left-icon="ni ni-hat-3">
                                    </base-input>
                                </div>
                                <p>Please enter your details (as representative):<p>
                                <div class="row">
                                    <base-input alternative
                                                v-model="contactFormData.firstName"
                                                class="mb-3 col noshadow"
                                                placeholder="First Name"
                                                addon-left-icon="ni ni-hat-3">
                                    </base-input>
                                    <base-input alternative
                                                v-model="contactFormData.lastName"
                                                class="mb-3 col noshadow"
                                                placeholder="Last Name"
                                                addon-left-icon="ni ni-hat-3">
                                    </base-input>
                                </div>
                                <div class="row">
                                    <base-input alternative
                                                v-model="contactFormData.email"
                                                class="mb-3 col noshadow"
                                                placeholder="Email Address"
                                                addon-left-icon="ni ni-hat-3">
                                    </base-input>
                                    <base-input alternative
                                                v-model="contactFormData.phone"
                                                class="mb-3 col noshadow"
                                                placeholder="Contact Phone"
                                                addon-left-icon="ni ni-hat-3">
                                    </base-input>
                                </div>
                                <div class="form-result">
                                    <!-- <p class="alert alert-success" v-if="success && !error">Message sent successfully.</p> -->
                                    <!-- <p class="alert alert-error" v-if="!success && error">Message failed.</p> -->
                                    <!-- <p class="alert alert-error" v-if="!valid">Message failed - org select.</p> -->
                                        <base-alert v-if="success && !error" type="success">
                                            <strong>Success!</strong> Your message has been successfully sent to our Admins!
                                        </base-alert>
                                        <base-alert v-if="!success && error && valid" type="success">
                                            <strong>Error!</strong> The message did not send!
                                        </base-alert>
                                        <base-alert v-if="!success && error && !valid" type="warning">
                                            <strong>Not sent!</strong> All fields are required, including the selection of an organisation type!
                                        </base-alert>
                                </div>
                                <div class="text-center">
                                    <base-button :disabled="disabled" type="success" class="my-4" @click='sendMail'>Send Request</base-button>
                                </div>
                            </form>
                        </template>
                    </card>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import BaseDropdown from '../components/BaseDropdown.vue';
export default {
  components: { BaseDropdown },
    name: 'ContactForm',
    data: function () {
        return {
            contactFormData: {
                orgName: '',
                orgCountry: '',
                orgAddress: '',
                email: '',
                firstName: '',
                lastName: '',
                phone:'',
                selected: ''
            },
            success: false,
            error: false,
            valid: true, 
            disabled: false
        }
    },
    watch: {
        selected: function (val) {
          if (val != '') {
            this.valid = true
          }
        }
    },
    methods: {
        sendMail: function () {
            if (this.contactFormData.selected != '' && this.contactFormData.orgName != '' && this.contactFormData.orgCountry != '' && this.contactFormData.orgAddress != '' && this.contactFormData.email != '' && this.contactFormData.firstName != '' && this.contactFormData.lastName != '' && this.contactFormData.phone != '') {         
                const url = ' https://us-central1-adeptprod-11172.cloudfunctions.net/sendEmailCF';
                const {orgName, orgCountry, orgAddress, email, firstName, lastName, phone, selected} = this.contactFormData;
                const payload = {orgName, orgCountry, orgAddress, email, firstName, lastName, phone, selected};
                this.disabled = true
                fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(payload)
                })
                    .then(() => {
                        this.valid = true;
                        this.success = true;
                        this.error = false;
                        this.disabled = false;
                        this.resetForm();
                    })
                    .catch(() => {
                        this.error = true;
                    })
            } else {
                console.log(this.contactFormData)
                this.valid = false;
                this.error = true;
            }
        },
        resetForm: function () {
            this.contactFormData = {
                orgName: '',
                orgCountry: '',
                orgAddress: '',
                email: '',
                firstName: '',
                lastName: '',
                phone:'',
                selected: ''
            };
        },
    }
}
</script>
<style>
.noshadow {
    box-shadow: none !important;
}
</style>
